/* eslint-disable */
import React, { useState } from 'react'
import styled from '@emotion/styled'
import { node } from 'prop-types'

const RouteAButton = styled.a`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  font-weight: normal;
  max-height: 40px;
  padding-top: 7px;
  padding-bottom: 6px;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 999em;
  border: none;
  font-size: 18px;
  font-family: 'Titillium Web';
  text-decoration: none;
`

const Button = ({ children, ...props }) => {
  return <RouteAButton {...props}>{children}</RouteAButton>
}

Button.propTypes = {
  children: node.isRequired,
}

export default Button
